module.exports = __webpack_public_path__ + "img/icon_informed_delivery.67ca0972.svg";